/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Bar_Playing_FinalsInputs */



/**
* | output |
* | --- |
* | "Finals in progress. Set scores on the Finals tab." |
*
* @param {Action_Bar_Playing_FinalsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const action_bar_playing_finals = /** @type {((inputs?: Action_Bar_Playing_FinalsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Bar_Playing_FinalsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Finale en cours. Saisissez les scores dans l'onglet Finale.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Final en curso. Establezca las puntuaciones en la pestaña Final.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Final em andamento. Defina as pontuações na aba Final.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Finale in corso. Imposta i punteggi nella scheda Finale.")
	return /** @type {LocalizedString} */ ("Finals in progress. Set scores on the Finals tab.")
});